import { render, staticRenderFns } from "./page-agent-royalty-manage.vue?vue&type=template&id=1e3d7016&scoped=true&"
import script from "./page-agent-royalty-manage.vue?vue&type=script&lang=js&"
export * from "./page-agent-royalty-manage.vue?vue&type=script&lang=js&"
import style0 from "./page-agent-royalty-manage.vue?vue&type=style&index=0&id=1e3d7016&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d7016",
  null
  
)

export default component.exports